import { ArrowForward, Close } from "@mui/icons-material"
import { Button, Dialog, Divider, FormControl, FormLabel, Grid, IconButton, TextField, Typography } from "@mui/material"

export const DownloadQuotationDialog = ({open, setOpen}: {open: boolean, setOpen: Function}) => {
    return <Dialog open={open} onClose={() => setOpen(false)} maxWidth={'xs'}>
        <Grid container sx={{ paddingX: '18px', paddingY: '16px' }}>
            <Grid item container display={'flex'} direction={'row'} sx={{ justifyContent: 'space-between' }}>
                <Grid item xs={10} sm={10} lg={11} md={11} xl={11}>
                    <Typography sx={{ fontWeight: '400', fontSize: '20px', textAlign: 'center' }}>
                        ¡Confirma tu correo para que podamos enviarte tu cotización por correo electrónico y ayudarte a encontrar la mejor oferta!
                    </Typography>
                </Grid>
                <Grid item>
                    <IconButton size="small" onClick={() => setOpen(false)}>
                       <Close />
                    </IconButton>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginY={3}>
                <Divider variant="middle" sx={{ backgroundColor: '#C7C7C7' }} />
            </Grid>
            <Grid item container rowGap={3}>
                <Grid item container xs={12} sm={12} md={12} lg={12} xl={12} flexDirection={'column'} rowGap={2}>
                    <Grid item>
                        <FormLabel sx={{ fontSize: '14px', fontWeight: '600' }}>¿Tu correo?</FormLabel>
                    </Grid>
                    <Grid item>
                        <TextField fullWidth placeholder="Correo electrónico" />
                    </Grid>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Button fullWidth variant="contained" endIcon={<ArrowForward />} sx={{ textTransform: 'none', height: '55.09px', fontSize: '16px' }}>Enviar</Button>
                </Grid>
            </Grid>
        </Grid>
    </Dialog>
}